<template>
  <div class="animated fadeIn products">
    <!-- new product dialog -->
    <v-dialog v-model="newItemDialog" width="600px">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت محصول جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newItemDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="نام *"
                v-model="newItem.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <vuetify-money
                label="قیمت (ریال) *"
                v-model="newItem.price"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                dense
                class="w-100"
              />
            </v-col>
            <!-- <v-col cols="12">
              <vuetify-money
                label="قیمت عمده فروشی (ریال) *"
                v-model="newItem.wholesalePrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                dense
                class="w-100"
              />
            </v-col>
            <v-col cols="12">
              <vuetify-money
                label="قیمت خرده فروشی (ریال) *"
                v-model="newItem.retailPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                type="number"
                outlined
                dense
                class="w-100"
              />
            </v-col> -->
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="تعداد اولیه *"
                v-model="newItem.amount"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="متریال"
                v-model="newItem.material"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="پوشش"
                v-model="newItem.coating"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="استاندارد ابعاد"
                v-model="newItem.dimensionStandard"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="قطر"
                v-model="newItem.diameter"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="طول"
                v-model="newItem.length"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="واحد اندازه‌گیری"
                v-model="newItem.measurementUnit"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                dense
                label="توضیحات"
                v-model="newItem.description"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 ps-4 pe-4">
          <v-btn
            class="red-borderedBtn ms-2 me-2"
            @click="newItemDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addItem()"
            :disabled="isBusy || computedNewBtn"
            class="purple-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-card class="common-card">
      <div class="d-flex flex-row">
        <v-row>
          <v-col cols="12">
            <h4 class="c-grey pt-2">مدیریت محصولات</h4>
          </v-col>
          <v-col cols="12">
            <div class="custom-input2">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو..."
                @input="currentPage = 1"
                prepend-icon="$Search"
                v-model="filter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="filter.length"
                    class="red--text text--lighten-2"
                    @click="
                      filter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </div>
      <hr class="mt-5" />
      <v-tabs v-model="tab">
        <v-tab
          @click="
            filter = '';
            currentPage = 1;
            perPage = 10;
          "
        >
          انبارداری
        </v-tab>
        <v-tab
          @click="
            searchExchanges();
            filter = '';
            currentPage = 1;
            perPage = 10;
          "
        >
          رسید و حواله
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <v-card v-if="cardLoading" flat>
            <div class="d-flex flex-column align-items-center mt-8 py-6">
              <cube></cube>
              <p class="c-purple font-weight-bold mt-4">
                در حال بارگذاری اطلاعات...
              </p>
            </div>
          </v-card>
          <v-card v-else flat>
            <v-container class="pt-6">
              <v-row>
                <v-col class="d-flex flex-row">
                  <h4 class="c-purple">انبارداری فروشگاه</h4>
                  <span style="padding-top: 2px" class="c-grey ms-4"
                    >({{ allItems.length }} کالا)</span
                  >
                </v-col>
                <v-col class="text-left">
                  <v-btn
                    @click="openNewItemDialog()"
                    @shortkey="openNewItemDialog()"
                    v-shortkey.once="['n']"
                    class="purple-borderedBtn"
                    height="43"
                  >
                    <v-icon class="me-1">$AddSquare</v-icon>
                    افزودن محصول جدید
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <div class="checkbox my-3" fluid>
                <v-row>
                  <v-checkbox
                    class="ms-2"
                    v-model="wholesaleCheckbox"
                    :label="`فروش عمده`"
                  ></v-checkbox>
                  <v-checkbox
                    class="ms-3"
                    v-model="retailCheckbox"
                    :label="`فروش خرده`"
                  ></v-checkbox>
                </v-row>
              </div> -->
              <v-row>
                <v-col cols="12">
                  <div class="me-4 mt-2">مرتب ‌سازی براساس:</div>
                </v-col>
                <v-col class="c-grey d-md-flex flex-row flex-wrap">
                  <div
                    v-for="(item, index) in sortOptions"
                    :key="index"
                    class="sort-box me-1 pointer"
                    @click="selectedSort = item"
                    :class="selectedSort == item ? 'selected-sort' : ''"
                  >
                    {{ item }}
                  </div>
                </v-col>
              </v-row>

              <hr />
              <vue-excel-xlsx
                :data="computedItems"
                class="darkGreen-mainBtn mb-4 float-start"
                style="width: 135px; height: 35px"
                :class="computedItems.length ? 'white--text' : 'disabled-excel'"
                :columns="excelFields"
                :file-name="'انبارداری فروشگاه '"
                :sheet-name="`انبارداری فروشگاه`"
              >
                <v-icon :class="computedItems.length ? 'white--text' : ''"
                  >mdi-file-excel-outline</v-icon
                >
                خروجی اکسل
              </vue-excel-xlsx>
              <v-btn
                class="darkRed-mainBtn white--text mb-4 float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt()"
                depressed
                :disabled="gettingReceipt || !computedItems.length"
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
              <div class="custom-table mt-3">
                <b-table
                  responsive
                  show-empty
                  id="productsTable"
                  :items="computedItems"
                  :fields="fields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                  :current-page="currentPage"
                  :per-page="perPage"
                  :busy="isBusy"
                  :filter="filter"
                  thead-class="headClass"
                  tbody-class="bodyClass"
                  @filtered="onFiltered"
                >
                  <template v-slot:empty>
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      رکوردی برای نمایش وجود ندارد.
                    </div>
                  </template>
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>

                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(price)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value.toLocaleString() }} ریال
                    </div>
                  </template>
                  <template v-slot:cell(operation)="row">
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      <v-btn
                        v-if="!row.item._showDetails"
                        @click="row.toggleDetails"
                        class="purple-mainBtn"
                        width="120"
                        >نمایش عملیات</v-btn
                      >
                      <v-btn
                        v-else
                        @click="row.toggleDetails"
                        class="red-mainBtn"
                        width="120"
                        >بستن عملیات</v-btn
                      >
                    </div>
                  </template>
                  <template #row-details="row">
                    <div
                      class="animated fadeIn mb-2"
                      style="text-align: center; vertical-align: middle"
                    >
                      <v-btn
                        class="purple-mainBtn ms-2 me-2"
                        width="155"
                        height="40"
                        @click="openEditModal(row.item)"
                        ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                        >ویرایش</v-btn
                      >
                      <v-btn
                        class="green-mainBtn ms-2 me-2"
                        width="155"
                        height="40"
                        @click="addEntryDialog(row.item)"
                        ><v-icon class="me-1">mdi-plus-box-outline</v-icon
                        >افزایش موجودی</v-btn
                      >
                      <v-btn
                        class="lime-mainBtn ms-2 me-2"
                        width="155"
                        height="40"
                        @click="openDialog(row.item, 'decrease')"
                        :disabled="!Number(row.item.sum)"
                        ><v-icon class="me-1">mdi-minus-box-outline</v-icon>کاهش
                        موجودی</v-btn
                      >
                    </div>
                  </template>

                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <strong>در حال بارگذاری...</strong>
                    <br />
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </b-table>
                <v-row class="mt-6">
                  <v-col>
                    <v-col class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box-new">
                        <v-select
                          class="shop-select"
                          attach
                          :menu-props="{ top: true, offsetY: true }"
                          outlined
                          dense
                          v-model="perPage"
                          :items="perPageOptions"
                          @change="currentPage = 1"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-col>
                  <v-col>
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedItems.length / perPage)"
                        :total-visible="5"
                        :per-page="perPage"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        aria-controls="productsTable"
                        class="float-end"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-container class="pt-6">
            <v-card v-if="exchangeIsBusy" flat>
              <div class="d-flex flex-column align-items-center mt-8 py-6">
                <cube></cube>
                <p class="c-purple font-weight-bold mt-4">
                  در حال بارگذاری اطلاعات...
                </p>
              </div>
            </v-card>
            <v-card v-else flat>
              <v-row>
                <v-col class="d-flex flex-row">
                  <h4 class="c-purple">رسید و حواله فروشگاه</h4>
                  <span style="padding-top: 2px" class="c-grey ms-4"
                    >({{ allExchanges.length }} رسید و حواله)</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col class="c-grey d-flex flex-row flex-wrap">
                  <div class="customSelect2 me-4 pb-0 mt-2">
                    <span class="c-blue pt-3 pe-2"> فیلتر نوع </span>
                    <v-select
                      attach
                      class="shop-select"
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      outlined
                      hide-details
                      :items="types"
                      v-model="typeFilter"
                      @change="currentPage = 1"
                    >
                      <template v-slot:append>
                        <v-icon class="c-blue">$ArrowDown</v-icon>
                      </template>
                    </v-select>
                  </div>
                  <MyCalendar
                    @submit="searchExchanges()"
                    @getStartDate="getStartDate"
                    @getEndDate="getEndDate"
                    :label="'فیلتر زمانی'"
                    :icon="'arrow'"
                    :start="startDate"
                    :end="endDate"
                    class="mt-2"
                  />
                </v-col>
              </v-row>
              <hr />
              <vue-excel-xlsx
                :data="computedExchanges"
                class="darkGreen-mainBtn mb-4 float-start"
                style="width: 135px; height: 35px"
                :columns="excelExchangesFields"
                :file-name="'رسید و حواله فروشگاه '"
                :sheetname="`رسید و حواله فروشگاه`"
                :class="
                  computedExchanges.length ? 'white--text' : 'disabled-excel'
                "
              >
                <v-icon :class="computedItems.length ? 'white--text' : ''"
                  >mdi-file-excel-outline</v-icon
                >
                خروجی اکسل
              </vue-excel-xlsx>
              <v-btn
                :disabled="!computedExchanges.length"
                class="darkRed-mainBtn white--text mb-4 float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt2()"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
              <div class="custom-table mt-3">
                <b-table
                  responsive
                  show-empty
                  id="detailsTable"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :items="computedExchanges"
                  :fields="exchangesFields"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد."
                  striped
                  thead-class="headClass"
                  tbody-class="bodyClass"
                  :busy="exchangeIsBusy"
                >
                  <template v-slot:empty>
                    <div
                      style="text-align: center; vertical-align: middle"
                      class="pt-0"
                    >
                      رکوردی برای نمایش وجود ندارد.
                    </div>
                  </template>
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(note)="data">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          style="text-align: center; vertical-align: middle"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{
                            data.value.length > 35
                              ? data.value.slice(0, 35) + "..."
                              : data.value
                          }}
                        </div>
                      </template>
                      <span class="fs-xsmall">{{ data.value }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 + perPage * (currentPage - 1) }}
                    </div>
                  </template>
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <strong>در حال بارگذاری...</strong>
                    <br />
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </b-table>
                <v-row class="mt-6">
                  <v-col>
                    <v-col class="d-flex flex-row">
                      <span class="c-grey pt-2">نمایش در هر صفحه</span>
                      <div class="ms-3 me-3 number-box-new">
                        <v-select
                          class="shop-select"
                          attach
                          :menu-props="{ top: true, offsetY: true }"
                          outlined
                          dense
                          v-model="perPage"
                          :items="perPageOptions"
                          @change="currentPage = 1"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-col>
                  <v-col>
                    <div>
                      <v-pagination
                        v-model="currentPage"
                        :length="Math.ceil(computedExchanges.length / perPage)"
                        :total-visible="5"
                        prev-icon="$ArrowLeft"
                        next-icon="$ArrowRight"
                        class="float-end"
                      ></v-pagination>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- increase dialog -->
    <v-dialog v-model="entryDialog" width="600px">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ورود کالا - افزایش موجودی</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="entryDialog = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <span id="entryDate">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="entry.date"
                  label="تاریخ ورود"
                  :editable="true"
                  class="date-input mb-1"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="entry.date"
                element="entryDate"
                color="#9c7fb7"
              />
            </v-col>
            <v-col cols="12">
              <span id="entryTime">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-clock-time-two-outline"
                  v-model="entry.time"
                  label="ساعت ورود"
                  :editable="true"
                  class="date-input mb-1"
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="entry.time"
                element="entryTime"
                color="#9c7fb7"
                type="time"
              />
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="حجم ورودی"
                v-model="entry.number"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                label="مبدا"
                v-model="entry.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-textarea
            outlined
            dense
            label="توضیحات"
            v-model="entry.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 ps-4 pe-4">
          <v-btn
            class="red-borderedBtn ms-2 me-2"
            width="90"
            @click="entryDialog = false"
          >
            لغو
          </v-btn>
          <v-btn
            class="purple-mainBtn white--text"
            width="90"
            @click="entrySubmit()"
            :disabled="computedSubmitBtn('entry')"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- edit product dialog -->
    <v-dialog v-model="editModal" width="600px">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">جزئیات محصول</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="editModal = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div v-if="isBusy2" class="text-center pb-5">
          <cube></cube>
          <span style="font-size: 16px">در حال بارگذاری ...</span>
        </div>
        <div v-else>
          <v-card-text class="custom-input">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="نام *"
                  v-model="info.name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <vuetify-money
                  label="قیمت (ریال) *"
                  v-model="info.price"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  hide-details
                  type="number"
                  outlined
                  dense
                  class="w-100"
                />
              </v-col>
              <!-- <v-col cols="12">
                <vuetify-money
                  label="قیمت عمده فروشی (ریال) *"
                  v-model="info.wholesalePrice"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  hide-details
                  type="number"
                  outlined
                  dense
                  class="w-100"
                />
              </v-col>
              <v-col cols="12">
                <vuetify-money
                  label="قیمت خرده فروشی (ریال) *"
                  v-model="info.retailPrice"
                  :valueWhenIsEmpty="whenIsEmpty"
                  :options="vMoneyOptions"
                  hide-details
                  type="number"
                  outlined
                  dense
                  class="w-100"
                />
              </v-col> -->
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="متریال"
                  v-model="info.material"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="پوشش"
                  v-model="info.coating"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="استاندارد ابعاد"
                  v-model="info.dimensionStandard"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="قطر"
                  v-model="info.diameter"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="طول"
                  v-model="info.length"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="واحد اندازه‌گیری"
                  v-model="info.measurementUnit"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  dense
                  label="توضیحات"
                  v-model="info.description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <div class="text-left py-3 ps-4 pe-4">
            <v-btn
              class="red-borderedBtn ms-2 me-2"
              width="90"
              @click="editModal = false"
            >
              لغو
            </v-btn>
            <v-btn
              class="purple-mainBtn white--text"
              width="90"
              @click="editItem()"
              :disabled="!info.name || !info.price"
            >
              ویرایش
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- decrease dialog -->
    <v-dialog v-model="decreaseDialog" width="600">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">خروج کالا - کاهش موجودی</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="decreaseDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <span id="leaveDate">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-calendar-edit"
                  v-model="selectedItem.date"
                  label="تاریخ خروج"
                  :editable="true"
                  class="date-input"
                  hide-details
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="selectedItem.date"
                element="leaveDate"
                color="#9c7fb7"
              />
            </v-col>
            <v-col cols="12">
              <span id="leaveTime">
                <v-text-field
                  outlined
                  dense
                  type="text"
                  append-icon="mdi-clock-time-two-outline"
                  v-model="selectedItem.time"
                  label="ساعت خروج"
                  :editable="true"
                  class="date-input"
                  hide-details
                >
                </v-text-field>
              </span>

              <date-picker
                v-model="selectedItem.time"
                element="leaveTime"
                color="#9c7fb7"
                type="time"
              />
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col cols="12">
              <v-text-field
                placeholder="حجم خروجی"
                outlined
                dense
                hide-details
                type="number"
                v-model="selectedItem.number"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                placeholder="مقصد"
                outlined
                dense
                hide-details
                v-model="selectedItem.origin"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-textarea
            placeholder="توضیحات"
            outlined
            dense
            v-model="selectedItem.description"
          ></v-textarea>
        </v-card-text>
        <div class="text-left py-3 ps-4 pe-4">
          <v-btn
            class="red-borderedBtn ms-2 me-2"
            @click="decreaseDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="exitSubmit()"
            class="purple-mainBtn white--text"
            width="90"
            :disabled="computedSubmitBtn('selectedItem')"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <router-view></router-view>

    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">انبارداری فروشگاه</h3>
      <b-table :items="computedItems" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
    <div id="printTable2" v-show="false">
      <h3 class="text-right" style="float: right">رسید و حواله فروشگاه</h3>
      <b-table :items="computedExchanges" :fields="exchangesFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables
import MyCalendar from "../../components/MyCalendar.vue";
import prices from "../../mixins/prices";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    
    MyCalendar,
  },

  mixins: [prices],
  data: function () {
    return {
      // wholesaleCheckbox: true,
      // retailCheckbox: true,
      cardLoading: false,
      calendarType: "startDate",
      decreaseDialog: false,
      startDate: "",
      endDate: "",
      tab: null,
      loading: false,
      excelFields: [
        { field: "name", label: "نام محصول" },
        { field: "price", label: "قیمت (ریال)" },
        { field: "sum", label: "موجودی" },
      ],
      sortOptions: [
        "کمترین موجودی",
        "بیشترین موجودی",
        //"پرفروش‌ترین",
        "ارزان‌ترین",
        "گران‌ترین",
      ],
      perPageOptions: [4, 10, 20],
      selectedSort: "کمترین موجودی",
      typeFilter: "همه",
      allItems: [],
      products: [],
      otherWarehouses: [],
      entry: {},
      entryDialog: false,
      productFilter: "all",
      entryDialog: false,
      newProductDialog: false,
      advanceFilter: false,
      adFilter: {},
      selected: "",
      selected2: [],
      entry: {},
      exit: {
        date: "",
        origin: "",
        description: "",
        number: "",
      },
      transfer: {},
      edit: {},
      newProduct: {},
      check: {
        name: false,
        material: false,
        coating: false,
        standard: false,
        diameter: false,
        length: false,
        number: false,
        description: false,
      },
      moment: moment,
      showProgress: false,
      items: [],
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: "",
      fields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد کالا" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "sum", label: "موجودی" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "کد کالا" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "sum", label: "موجودی" },
      ],
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      totalRows2: 1,
      exchangeFrom: "",
      exchangeTo: "",
      selectedItem: {},
      allExchanges: [],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "warehouseItemName", label: "کالا" },
        { key: "amount", label: "مقدار" },
        // { key: "status", label: "وضعیت" },
        // { key: "note", label: "توضیحات" },
        // { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "note", label: "توضیحات" },

        // { key: "operation", label: "عملیات" }
      ],
      excelExchangesFields: [
        { field: "type", label: "نوع" },
        { field: "warehouseItemName", label: "کالا" },
        { field: "amount", label: "مقدار" },
        { field: "userName", label: "کاربر" },
        { field: "date", label: "تاریخ" },
        { field: "note", label: "توضیحات" },
      ],
      exchangeCurrentPage: 1,
      exchangePerPage: 10,
      exchangeIsBusy: false,
      newItemDialog: false,
      newItem: {},
      type: Var.allTypes[3],
      types: ["همه", "رسید", "حواله"],
      editModal: false,
      info: {},
      gettingReceipt: false,
      testData: [],
    };
  },

  methods: {
    computedSubmitBtn(type) {
      if (
        this[type].date &&
        this[type].time &&
        this[type].number &&
        this[type].origin
      ) {
        return false;
      } else return true;
    },
    getStartDate(value) {
      this.startDate = value;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    openEditModal(item) {
      (this.info = {}), (this.selected = item);
      this.editModal = true;
      this.getInfo();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length;
      this.currentPage = 1;
    },
    addEntryDialog(item) {
      this.selectedItem = item;
      this.entry = {};
      this.entryDialog = true;
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/shopentrance",
        {
          warehouseItemId: this.selectedItem.id,
          warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.entry.number,
          date: this.entry.date + " " + this.entry.time,
          orgDes: this.entry.origin,
          note: this.entry.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.entry = {};
            this.getProducts();
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/new",
        {
          warehouseTypeId: this.type.id,
          name: this.newItem.name,
          amount: this.newItem.amount,
          description: this.newItem.description,
          material: this.newItem.material,
          coating: this.newItem.coating,
          dimensionStandard: this.newItem.dimensionStandard,
          diameter: this.newItem.diameter,
          length: this.newItem.length,
          price: this.newItem.price,
          measurementUnit: this.newItem.measurementUnit,
          // buyPrice: this.newItem.buyPrice,
          // wholesalePrice: this.newItem.wholesalePrice,
          // retailPrice: this.newItem.retailPrice,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newItemDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selected.id,
          name: this.info.name,
          description: this.info.description,
          material: this.info.material,
          coating: this.info.coating,
          dimensionStandard: this.info.dimensionStandard,
          diameter: this.info.diameter,
          length: this.info.length,
          price: this.info.price,
          measurementUnit: this.info.measurementUnit,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editModal = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    searchExchanges() {
      this.exchangeIsBusy = true;
      let startDate = this.startDate + " 00:00";
      let finishDate = this.endDate + " 23:59";
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/exchanges",
        {
          warehouseId: "6174364e034d1b5b3b880f6b",
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.exchangeIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    openDialog(item, type) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.selectedItem.date = moment(new Date()).format("jYYYY/jMM/jDD");
      this.selectedItem.time = moment(new Date()).format("HH:mm");
      this[type + "Dialog"] = true;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry = {};
    },
    openNewItemDialog() {
      this.newItemDialog = true;
      this.newItem = {};
    },
    getInfo() {
      this.isBusy2 = true;
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          this.loading = true;
          if (res.status == 200) {
            this.info = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          this.loading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/shopexit",
        {
          warehouseItemId: this.selectedItem.id,
          amount: this.selectedItem.number,
          date: this.selectedItem.date + " " + this.selectedItem.time,
          orgDes: this.selectedItem.origin,
          note: this.selectedItem.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.decreaseDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getProducts() {
      this.cardLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          this.cardLoading = false;
          if (res.status == 200) {
            this.allItems = res.data;
            this.totalRows2 = this.allItems.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.cardLoading = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    printReceipt2() {
      //printing receipt
      var myWindow = window.open("#", "printTable2", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable2").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
  },
  computed: {
    computedItems() {
      let filtered;
      filtered = this.allItems.filter(
        (x) =>
          x.name.toLowerCase().includes(this.filter.toLowerCase()) ||
          (x.code.toLowerCase().includes(this.filter.toLowerCase())) ||
          String(x.price).includes(this.filter) ||
          String(x.sum).includes(this.filter)
      );
      if (this.selectedSort == "کمترین موجودی") {
        filtered.sort(function (a, b) {
          return a.sum - b.sum;
        });
      } else if (this.selectedSort == "بیشترین موجودی") {
        filtered.sort(function (a, b) {
          return b.sum - a.sum;
        });
      }
      //else if (this.selectedSort == "پرفروش‌ترین") {
      //  filtered.sort(function (a, b) {
      //    return b.sell - a.sell;
      //  });
      //}
      else if (this.selectedSort == "ارزان‌ترین") {
        filtered.sort(function (a, b) {
          return a.price - b.price;
        });
      } else if (this.selectedSort == "گران‌ترین") {
        filtered.sort(function (a, b) {
          return b.price - a.price;
        });
      }

      return filtered;
    },
    computedExchanges() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.allExchanges.filter(
          (x) =>
            x.warehouseItemName.includes(this.filter) ||
            String(x.amount).includes(this.filter) ||
            x.userName.includes(this.filter) ||
            x.date.includes(this.filter) ||
            x.note.includes(this.filter) ||
            x.type.includes(this.filter)
        );
      } else {
        filtered = this.allExchanges.filter(
          (x) =>
            x.warehouseItemName.includes(this.filter) &&
            x.type == this.typeFilter
        );
      }
      return filtered;
    },
    computedNewBtn() {
      if (this.newItem.name && this.newItem.amount) {
        return false;
      } else return true;
    },
  },
  mounted() {
    this.getProducts();
    this.exchangeTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.exchangeFrom = moment(new Date());
    this.endDate = moment(new Date()).format("jYYYY/jMM/jDD");
    this.startDate = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
    this.searchExchanges();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.products {
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
}
.v-dialog {
  overflow-y: hidden !important;
}
// .checkbox {
//   width: 100%;
//   text-align: right;
//   display: flex;
//   width: 250px;
//   height: 50px;
// }
</style>
